import { ErrorWithViolations as r } from "./index7.mjs";
class e extends r {
}
export {
  e as UnprocessableContentError
};
